import type { Localizations } from "~/service/l10n";

const translations: Localizations = {
  'en-US': {
    'cookiebot.preferences' : 'preferences',
    'cookiebot.statistics' : 'statistics',
    'cookiebot.marketing' : 'marketing',
    'cookiebot.content_blocked' : "Please accept the %s cookies to see the content.",
    'cookiebot.change_consent' : 'Change consent',
    'offers.allDays': 'All days',
    'offers.allCategories': 'All categories',
    'offers.allOffers': 'All offers',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Close',
    'offers.seeWholeOffer': 'See whole offer',
    'offers.noOffers': 'Unfortunately no offers are currently available',
    'offers.noContent':'No content currently available',
    'offers.searchBox':'Search',
    'offers.clearSelection': 'Clear selection',
    'offers.openInfo':'Open offer description',
    'offers.daysLowestPrice': '30 day lowest price',
    'offers.store': 'Store',
    'offers.offer': 'Offer',
    'offers.send-email': 'Send email',
    'offers.valid': 'Valid',
    'search.noResults': 'No results',
    'search.placeholder': 'Search',
  },
  'fi-FI': {
    'cookiebot.preferences' : 'mieltymys',
    'cookiebot.statistics' : 'tilasto',
    'cookiebot.marketing' : 'markkinointi',
    'cookiebot.content_blocked' : 'Jos sisältö ei näy, hyväksythän %sevästeet.',
    'cookiebot.change_consent' : 'Muuta hyväksyntää',
    'offers.allDays': 'Kaikki päivät',
    'offers.allCategories': 'Kaikki toimialat',
    'offers.allOffers': 'Kaikki tarjoukset',
    'offers.showWishList': 'Näytä muistilista',
    'offers.closeOffer': 'Sulje',
    'offers.seeWholeOffer': 'Avaa koko tarjous',
    'offers.noOffers': 'Etuja ei valitettavasti tällä hetkellä ole saatavilla',
    'offers.noContent':'Ei näytettävää sisältöä juuri nyt',
    'offers.searchBox':'Haku',
    'offers.clearSelection': 'Tyhjennä valinnat',
    'offers.openInfo':'Avaa lisätiedot',
    'offers.daysLowestPrice': '30 pv alin hinta',
    'offers.store': 'Liike',
    'offers.offer': 'Tarjous',
    'offers.send-email': 'Lähetä sähköposti',
    'offers.valid': 'Voimassa',
    'search.noResults': 'Ei tuloksia',
    'search.placeholder': 'Hae',
  },
  'sv-SE': {
    'cookiebot.preferences' : 'preferens',
    'cookiebot.statistics' : 'statistik',
    'cookiebot.marketing' : 'marknadsförings',
    'cookiebot.content_blocked' : 'Vänligen acceptera %scookies för att se innehållet.',
    'cookiebot.change_consent' : 'Ändra ditt medgivande',
    'offers.allDays': 'Alla dagar',
    'offers.allCategories': 'Alla kategorier',
    'offers.allOffers': 'Alla erbjudanden',
    'offers.showWishList': 'Visa önskelista',
    'offers.closeOffer': 'Stäng',
    'offers.seeWholeOffer': 'See hela förmånen',
    'offers.noOffers': 'Tyvärr finns det för tillfället inga förmåner',
    'offers.noContent':'Inget innehåll tillgängligt för tillfället',
    'offers.searchBox':'Söka',
    'offers.clearSelection': 'Rensa val',
    'offers.openInfo':'Öppna erbjudandets info',
    'offers.daysLowestPrice': 'Lägsta pris 30 dagar',
    'offers.store': 'Butiker',
    'offers.offer': 'Erbjudanden',
    'offers.send-email': 'Skicka e-post',
    'offers.valid': 'Gäller',
    'search.noResults': 'Inga resultat',
    'search.placeholder': 'Sök'
  },
  'nb-NO': {
    'cookiebot.preferences' : 'preferanse',
    'cookiebot.statistics' : 'statistikk',
    'cookiebot.marketing' : 'markedsførings',
    'cookiebot.content_blocked' : 'Godta %sinformasjonskapslene for å se innholdet.',
    'cookiebot.change_consent' : 'Endre samtykke',
    'offers.allDays': 'Alle dager',
    'offers.allCategories': 'Alle kategorier',
    'offers.allOffers': 'Alle tilbud',
    'offers.showWishList': 'Se ønskeliste',
    'offers.closeOffer': 'Lukk',
    'offers.seeWholeOffer': 'Se hele fordelen',
    'offers.noOffers': 'Dessverre ingen fordeler tilgjengelig for øyeblikket',
    'offers.noContent':'Inget innhold tilgjengelig for øyeblikket',
    'offers.searchBox':'Søk',
    'offers.clearSelection': 'Fjern valg',
    'offers.openInfo':'Les mer',
    'offers.daysLowestPrice': 'Laveste pris siste 30 dager',
    'offers.store': 'Butikker',
    'offers.offer': 'Tilbud',
    'offers.send-email': 'Send e-post',
    'offers.valid': 'Gyldig',
    'search.noResults': 'Ingen resultater',
    'search.placeholder': 'Søk'
  },
  'et-EE': {
    'cookiebot.preferences' : 'eelis',
    'cookiebot.statistics' : 'statistika',
    'cookiebot.marketing' : 'turundus',
    'cookiebot.content_blocked' : 'Sisu vaatamiseks nõustuge %sküpsistega.',
    'cookiebot.change_consent' : 'Muuda oma nõusolekut',
    'offers.allDays': 'Kõik päevad',
    'offers.allCategories': 'Kõik kategooriad',
    'offers.allOffers': 'Kõik pakkumised',
    'offers.showWishList': 'Vaata soovinimekirja',
    'offers.closeOffer': 'Sulge',
    'offers.seeWholeOffer': 'Vaata kogu soodustust',
    'offers.noOffers': 'Kahjuks hetkel soodustusi ei ole',
    'offers.noContent':'Hetkel sisu puudub',
    'offers.searchBox':'Otsi',
    'offers.clearSelection': 'Tühjenda valik',
    'offers.openInfo':'Ava pakkumise kirjeldus',
    'offers.daysLowestPrice': 'Viimase 30 päeva madalaim hind',
    'offers.store': 'Kauplused',
    'offers.offer': 'Pakkumised',
    'offers.send-email': 'Saada e-post',
    'offers.valid': 'Kehtib kuni',
    'search.noResults': 'Vasted puuduvad',
    'search.placeholder': 'Otsi'
  },
  'da-DK': {
    'cookiebot.preferences' : 'præference',
    'cookiebot.statistics' : 'statistik',
    'cookiebot.marketing' : 'marketing',
    'cookiebot.content_blocked' : 'Accepter %scookies for at se indholdet.',
    'cookiebot.change_consent' : 'Ændring af dit samtykke',
    'offers.allDays': 'Alle dage',
    'offers.allCategories': 'Alle kategorier',
    'offers.allOffers': 'Alle fordele',
    'offers.showWishList': 'Show wish list',
    'offers.closeOffer': 'Luk',
    'offers.seeWholeOffer': 'Se hele fordelen',
    'offers.noOffers': 'Der er desværre ingen fordele i øjeblikket',
    'offers.noContent':'Intet indhold tilgængeligt i øjeblikket',
    'offers.searchBox':'Søge',
    'offers.clearSelection': 'Ryd markering',
    'offers.openInfo':'Åbn tilbudsbeskrivelse',
    'offers.daysLowestPrice': 'Laveste pris de sidste 30 dage',
    'offers.store': 'Butikker',
    'offers.offer': 'Tilbud',
    'offers.send-email': 'Send e-mail',
    'offers.valid': 'Gyldig',
    'search.noResults': 'Ingen resultater',
    'search.placeholder': 'Søg'
  },
}

export default translations;